import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { apiGet, apiPost } from '../api.js';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const result = await apiGet('/auth/me');
      setUser(result.user);
      return true;
    } catch (err) {
      if (err.status === 401) {
        setUser(null);
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (username, password) => {
    const result = await apiPost('/auth/login', { username, password });
    if (result.token) {
      localStorage.setItem('token', result.token);
    }
    setUser(result.user);
  };

  const register = async (username, password) => {
    await apiPost('/auth/register', { username, password });
  };

  const logout = async () => {
    await apiPost('/auth/logout', {});
    localStorage.removeItem('token');
    setUser(null);
  };

  const value = useMemo(() => ({
    user,
    loading,
    isAuthenticated: Boolean(user),
    login,
    register,
    logout,
    refresh: checkAuth
  }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
